import pushGa4Event from '../../../utils/pushGa4Event'
import { toastSuccess } from '../../../global/notifications'
import { payNow, types } from './index'

// Kept apart from ./dispatchers (which imports the auth dispatchers) so the
// account page's dispatchers can use it without an import cycle.

const DECLINE_FALLBACK =
  "We couldn't charge your payment method. Your free trial is still active."

// SPEC-098 FR-2/FR-3: end a free trial by paying now. Resolves
// { success: true } (the account page updates from the returned
// subscription) or { success: false, message } with the backend's reason;
// a decline leaves the trial running, so the dialog shows the message and
// stays open.
const dispatchPayNow = (dispatch, subscription = {}) =>
  dispatch(payNow())
    .then(([_, res]) => {
      if (res.type === types.SUBSCRIPTION_SUMMARY_FETCH_SUCCESS) {
        pushGa4Event('GTMEvent', {
          eventCategory: 'Subscriptions',
          eventAction: 'Pay Now',
          eventLabel: subscription.plan
        })
        toastSuccess({
          success: {
            id: 'payNowSuccess',
            message: `Your membership is active. You were charged $${res.payload.price ?? subscription.price}.`
          }
        })
        return { success: true }
      }
      return {
        success: false,
        message: res.payload?.value?.detail || DECLINE_FALLBACK
      }
    })
    .catch(() => ({ success: false, message: DECLINE_FALLBACK }))

export default dispatchPayNow
